import {
  SwitchTransition as Transition,
  CSSTransition,
} from "react-transition-group";

/**
 * 切换过度动画
 * @param {*} param0
 * @returns
 */
export default function SwitchTransition({
  type = "swiper-right",
  switchKey,
  children,
  mode = "out-in",
  duration = 350,
}) {
  return (
    <Transition mode={mode}>
      <CSSTransition key={switchKey} classNames={type} timeout={duration}>
        {children}
      </CSSTransition>
    </Transition>
  );
}
